import React from 'react';
import Layout from '../components/layout/Layout';

function AgreementPage() {
  return (
    <Layout>
      <section className="section-agreement">
        <div className="container text-center" style={{ paddingTop: '40px', paddingBottom: '40px' }}>
          <h1 className="agreement__title q-mb-lg">Правовые документы</h1>

          <div className="d-flex justify-content-center align-content-center">
            <div className="d-flex justify-content-between flex-column gap-4">
              <a
                className="q-btn q-btn--standard bg-deep-orange text-white q-btn--actionable q-btn--no-uppercase"
                tabIndex="0"
                target="_blank"
                rel="noopener noreferrer"
                href={`/docs/public-offer.pdf`}
              >
                Публичная оферта / Пользовательское соглашение
              </a>
              <a
                className="q-btn q-btn--standard bg-deep-orange text-white q-btn--actionable q-btn--no-uppercase"
                tabIndex="0"
                target="_blank"
                rel="noopener noreferrer"
                href={`/docs/personal-data-policy.pdf`}
              >
                Политика обработки персональных данных
              </a>
              <a
                className="q-btn q-btn--standard bg-deep-orange text-white q-btn--actionable q-btn--no-uppercase"
                tabIndex="0"
                target="_blank"
                rel="noopener noreferrer"
                href={`/docs/consent-personal-data.pdf`}
              >
                Согласие на обработку персональных данных
              </a>
              <a
                className="q-btn q-btn--standard bg-deep-orange text-white q-btn--actionable q-btn--no-uppercase"
                tabIndex="0"
                target="_blank"
                rel="noopener noreferrer"
                href={`/docs/cookie-policy.pdf`}
              >
                Согласие на обработку файлов cookie
              </a>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}

export default AgreementPage;
